export const testimonials = [
  {
    id: 1,
    name: "Jake Morrison",
    trade: "Carpenter",
    location: "Sydney, NSW",
    rating: 5,
    image: "https://public.readdy.ai/ai/img_res/773d2141a76ee995d0bdcfa7e234130b.jpg",
    quote: "Cut my quoting time from 4 hours to 15 minutes. The AI material calculator is spot-on every time. Already won 3 extra jobs this month because I can respond faster than my competitors.",
    jobsCompleted: 47,
    timeUsing: "8 months"
  },
  {
    id: 2,
    name: "Sarah Chen",
    trade: "Electrician",
    location: "Melbourne, VIC",
    rating: 5,
    image: "https://readdy.ai/api/search-image?query=professional%20female%20australian%20electrician%20smiling%20portrait%20wearing%20high%20visibility%20work%20shirt%20and%20tool%20belt%20on%20commercial%20building%20site%20natural%20lighting%20confident%20pose&width=120&height=120&seq=testimonial-sarah-chen&orientation=squarish",
    quote: "The GPS tracking feature alone saves me $800/month in wasted travel time. My team knows exactly where to go, and clients love the live updates. This platform pays for itself 10x over.",
    jobsCompleted: 134,
    timeUsing: "1 year"
  },
  {
    id: 3,
    name: "Tom Bradley",
    trade: "Plumber",
    location: "Brisbane, QLD",
    rating: 5,
    image: "https://readdy.ai/api/search-image?query=professional%20australian%20plumber%20tradesman%20smiling%20portrait%20wearing%20blue%20work%20uniform%20and%20cap%20holding%20clipboard%20on%20residential%20job%20site%20natural%20lighting%20friendly%20expression&width=120&height=120&seq=testimonial-tom-bradley&orientation=squarish",
    quote: "Best investment I've made for my business. The invoice templates look so professional, clients pay faster. Went from 45-day payment cycles to 14 days average. Game changer.",
    jobsCompleted: 89,
    timeUsing: "6 months"
  },
  {
    id: 4,
    name: "Marcus Williams",
    trade: "Builder",
    location: "Perth, WA",
    rating: 5,
    image: "https://readdy.ai/api/search-image?query=professional%20australian%20builder%20construction%20manager%20smiling%20portrait%20wearing%20hard%20hat%20and%20high%20visibility%20vest%20on%20building%20site%20with%20house%20frame%20background%20natural%20lighting%20confident&width=120&height=120&seq=testimonial-marcus-williams&orientation=squarish",
    quote: "Managing 5 crews across Perth was chaos before MTA Planner Pro. Now I can see everyone's location, schedule jobs efficiently, and our profit margins increased 18% in 3 months.",
    jobsCompleted: 203,
    timeUsing: "14 months"
  },
  {
    id: 5,
    name: "Dean Patterson",
    trade: "Tiler",
    location: "Gold Coast, QLD",
    rating: 5,
    image: "https://readdy.ai/api/search-image?query=professional%20australian%20tiler%20tradesman%20smiling%20portrait%20wearing%20work%20polo%20shirt%20holding%20tile%20samples%20on%20bathroom%20renovation%20site%20natural%20lighting%20experienced%20craftsman&width=120&height=120&seq=testimonial-dean-patterson&orientation=squarish",
    quote: "The material calculator is insanely accurate. Used to over-order tiles by 20% just to be safe. Now I'm within 2-3% every job. Saved thousands in wasted materials already.",
    jobsCompleted: 67,
    timeUsing: "5 months"
  },
  {
    id: 6,
    name: "Rachel Thompson",
    trade: "Painter",
    location: "Adelaide, SA",
    rating: 5,
    image: "https://readdy.ai/api/search-image?query=professional%20female%20australian%20painter%20tradeswoman%20smiling%20portrait%20wearing%20white%20painters%20overalls%20and%20cap%20holding%20paint%20roller%20on%20residential%20interior%20job%20site%20natural%20lighting%20friendly&width=120&height=120&seq=testimonial-rachel-thompson&orientation=squarish",
    quote: "Love how easy it is to send quotes from my phone on-site. Clients are impressed with the professional PDFs. Won a $12k job because I quoted while still at their house.",
    jobsCompleted: 52,
    timeUsing: "4 months"
  }
];

export const trustMetrics = {
  totalTradies: "2,400+",
  totalInvoiced: "$8.7M",
  averageRating: 4.9,
  totalReviews: 847,
  averageTimeSaved: "6.2 hours/week",
  averageRevIncrease: "23%"
};

export const invoiceScreenshots = [
  {
    id: 1,
    title: "Professional Invoice Template",
    description: "Clean, branded invoices that get paid faster",
    image: "https://readdy.ai/api/search-image?query=professional%20tradie%20invoice%20template%20screenshot%20showing%20detailed%20line%20items%20materials%20labour%20costs%20GST%20total%20payment%20terms%20company%20logo%20clean%20modern%20layout%20white%20background%20business%20document&width=600&height=800&seq=invoice-screenshot-1&orientation=portrait"
  },
  {
    id: 2,
    title: "Material Breakdown Quote",
    description: "Detailed material lists with supplier pricing",
    image: "https://readdy.ai/api/search-image?query=construction%20quote%20document%20screenshot%20showing%20itemized%20material%20breakdown%20quantities%20unit%20prices%20subtotals%20professional%20layout%20with%20company%20branding%20clean%20white%20background%20business%20format&width=600&height=800&seq=invoice-screenshot-2&orientation=portrait"
  },
  {
    id: 3,
    title: "Job Schedule Report",
    description: "Weekly schedule exports for team coordination",
    image: "https://readdy.ai/api/search-image?query=weekly%20job%20schedule%20report%20screenshot%20showing%20calendar%20view%20with%20multiple%20jobs%20team%20assignments%20addresses%20times%20professional%20layout%20clean%20design%20white%20background%20business%20document%20format&width=600&height=800&seq=invoice-screenshot-3&orientation=portrait"
  }
];

export const certifications = [
  {
    id: 1,
    name: "Australian Business Number",
    abn: "51 824 753 916",
    verified: true
  },
  {
    id: 2,
    name: "Secure Payment Processing",
    provider: "Stripe",
    verified: true
  },
  {
    id: 3,
    name: "Data Protection Compliant",
    standard: "ISO 27001",
    verified: true
  },
  {
    id: 4,
    name: "Built for Australian Trades",
    description: "GST compliant, ATO ready",
    verified: true
  }
];